'use client';

import {useWakeLock} from '@/lib/useWakeLock';

/**
 * Client component that initializes the wake lock to keep the screen on.
 * This component renders nothing - it only runs the hook.
 */
export default function WakeLockProvider(): null {
    useWakeLock();
    return null;
}
